import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Changelog14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path d='M13.5 2.75L7 2.75V1.25H13.5V2.75Z' fill='currentColor' />
    <path
      d='M0.469727 7.03033L1.53039 5.96967L2.25 6.68928V4C2.25 2.48122 3.48122 1.25 5 1.25H5.5V2.75H5C4.30964 2.75 3.75 3.30964 3.75 4V6.68939L4.46973 5.96967L5.53039 7.03033L3.00006 9.56066L0.469727 7.03033Z'
      fill='currentColor'
    />
    <path d='M2 12.75H4V11.25H2V12.75Z' fill='currentColor' />
    <path d='M7 12.75L13.5 12.75V11.25L7 11.25V12.75Z' fill='currentColor' />
    <path d='M7 7.75L13.5 7.75V6.25L7 6.25V7.75Z' fill='currentColor' />
  </Svg>
);

Changelog14.displayName = 'Changelog14';
export default Changelog14;
